import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';

export function FinalCTA() {
  return (
    <section className="mesh-bg relative overflow-hidden border-t border-line bg-board py-24">
      <div className="relative z-10 mx-auto max-w-3xl px-6 text-center">
        <h2 className="mb-6 font-display text-3xl font-semibold tracking-tight text-ink md:text-5xl">
          You've been meaning to do this for months.
        </h2>
        <p className="mb-8 text-lg text-ink-muted">
            Free. Everything included. No "unlock Pro to get the good templates." There is no Pro. This is just the thing.
        </p>
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="/sign-in" className="w-full sm:w-auto">
            <Button variant="primary" size="lg" fullWidth>
              Build your portfolio
            </Button>
          </Link>
        </div>
        <p className="mt-6 font-mono text-xs text-ink-faint">
          built by one person · probably has bugs · feedback genuinely welcome
        </p>
      </div>
    </section>
  );
}
